import { HTTPClient, propsToDate } from '@abaco/web-common/src/HTTP';
import { Reading, Sensor, SensorXResult, Station } from '../models/SensorX';


export default class SeedApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient) {
        this.http = http;
        this.rootPath = '/sensor-x/api/v1'
    }

    async getStations(subjectId: number) {
        const url = `${this.rootPath}/farm/${subjectId}/stations`;
        const res = (await this.http.get<SensorXResult<Station[]>>(url)).data.results;
        // res.forEach(r => propsToDate(r, ["date"]));
        return res.filter(r => r.type !== "EQUIPMENT_TRACK");
    }

    async getSensors(subjectId: number, stationId: string) {
        const url = `${this.rootPath}/farm/${subjectId}/stations/${stationId}/sensors`;
        const res = (await this.http.get<SensorXResult<Sensor[]>>(url)).data.results;
        res.forEach(r => propsToDate(r, ["date"]));
        return res;
    }

    async getReadingsBySensor(subjectId: number, stationId: string, sensorId: string, startDate: Date, endDate: Date) {
        const url = `${this.rootPath}/farm/${subjectId}/stations/${stationId}/sensors/${sensorId}/data`
        const params = {
            from: startDate,
            to: endDate
        }
        const res = (await this.http.get<SensorXResult<Reading[]>>(url, {params})).data.results;
        res.forEach(r => propsToDate(r, ["when"]));
        return res;
    }
}
